var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-button-icon"},[(!_vm.isLoading)?_c('button',{class:( _obj = {
      'cursor-default': _vm.disabled
    }, _obj[_vm.customClassName] = _vm.customClassName, _obj ),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('v-icon',{attrs:{"size":"20","color":_vm.renderButtonColor}},[_vm._v(_vm._s(_vm.icon))])],1):_c('div',{staticClass:"d-flex align-center"},[_c('v-progress-circular',{staticClass:"ml-1 mt-4",attrs:{"indeterminate":"","color":"#9e9e9e","size":"15","width":"2"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }